export default __webpack_public_path__ + "static/media/N-spanish.249bf7dd.svg";